export default {
    cause_death_types: {
        titles: "Causas de Morte",
        title: "Causa de Morte",
        model: {
            name: "Nome",
            status: "Ativo",
            code: "código"
        },
        list: {
            name: "@:cause_death_types.model.name",
            status: "@:cause_death_types.model.status",
            code: "@:cause_death_types.model.code"
        }
    },
    document_location_types: {
        titles: "Localização Documentos",
        title: "Localização Documento",
        list: {
            name: "@:document_location_types.model.name",
            status: "@:document_location_types.model.status",
            code: "@:document_location_types.model.code"
        },
        model: {
            name: "Nome",
            status: "Ativo",
            code: "código"
        }
    },
    document_types: {
        titles: "Tipos Documento",
        title: "Tipo Documento",
        list: {
            name: "@:document_types.model.name",
            status: "@:document_types.model.status",
            code: "@:document_types.model.code"
        },
        model: {
            name: "Nome",
            status: "Ativo",
            code: "código"
        }
    },
    genders: {
        titles: "Géneros",
        title: "Género",
        list: {
            name: "@:genders.model.name",
            status: "@:genders.model.status",
            code: "@:genders.model.code"
        },
        model: {
            name: "Nome",
            status: "Ativo",
            code: "código"
        }
    },
 
    occupant_types: {
        titles: "Tipos Ocupante",
        title: "Tipo Ocupante",
        list: {
            name: "@:occupant_types.model.name",
            status: "@:occupant_types.model.status",
            code: "@:occupant_types.model.code"
        },
        model: {
            name: "Nome",
            status: "Ativo",
            code: "código"
        }
    },
    occupation_position_types: {
        titles: "Tipos Posição Ocupação",
        title: "Tipo Posição Ocupação",
        list: {
            name: "@:occupation_position_types.model.name",
            status: "@:occupation_position_types.model.status",
            code: "@:occupation_position_types.model.code"
        },
        model: {
            name: "Nome",
            status: "Ativo",
            code: "código"
        }
    },

    occupation_types: {
        titles: "Tipos Ocupação",
        title: "Tipo Ocupação",
        list: {
            name: "@:occupation_types.model.name",
            status: "@:occupation_types.model.status",
            code: "@:occupation_types.model.code",
            color: "@:occupation_types.model.color"
        },
        model: {
            name: "Nome",
            status: "Ativo",
            code: "código",
            color: "Côr"
        }
    },
    sector_types: {
        titles: "Tipos Setor",
        title: "Tipo Setor",
        list: {
            name: "@:sector_types.model.name",
            status: "@:sector_types.model.status",
            code: "@:sector_types.model.code",
            color: "@:sector_types.model.color"
        },
        model: {
            name: "Nome",
            status: "Ativo",
            code: "código",
            color: "Côr"
        }
    },
    container_types: {
        titles: "Tipos Urna",
        title: "Tipo Urna",
        list: {
            name: "@:container_types.model.name",
            status: "@:container_types.model.status",
            code: "@:container_types.model.code"
        },
        model: {
            name: "Nome",
            status: "Ativo",
            code: "código"
        }
    },
    deed_owner_holder_end_types: {
        titles: "Tipos Fim Titularidade",
        title: "Tipo Fim Titularidade",
        list: {
            name: "@:deed_owner_holder_end_types.model.name",
            status: "@:deed_owner_holder_end_types.model.status",
            code: "@:deed_owner_holder_end_types.model.code"
        },
        model: {
            name: "Nome",
            status: "Ativo",
            code: "código"
        }
    },
    deed_owner_holder_start_types: {
        titles: "Tipos Início Titularidade",
        title: "Tipo Início Titularidade",
        list: {
            name: "@:deed_owner_holder_start_types.model.name",
            status: "@:deed_owner_holder_start_types.model.status",
            code: "@:deed_owner_holder_start_types.model.code"
        },
        model: {
            name: "Nome",
            status: "Ativo",
            code: "código"
        }
    },
    interment_types: {
        titles: "Tipos Enterro",
        title: "Tipo Enterro",
        list: {
            name: "@:interment_types.model.name",
            status: "@:interment_types.model.status",
            code: "@:interment_types.model.code"
        },
        model: {
            name: "Nome",
            status: "Ativo",
            code: "código"
        }
    },
    intervention_types: {
        titles: "Tipos Intervenção",
        title: "Tipo Intervenção",
        list: {
            name: "@:intervention_types.model.name",
            status: "@:intervention_types.model.status",
            code: "@:intervention_types.model.code"
        },
        model: {
            name: "Nome",
            status: "Ativo",
            code: "código"
        }
    },
    occupation_direction_types: {
        titles: "Tipos Orientação",
        title: "Tipo Orientação",
        list: {
            name: "@:occupation_direction_types.model.name",
            status: "@:occupation_direction_types.model.status",
            code: "@:occupation_direction_types.model.code"
        },
        model: {
            name: "Nome",
            status: "Ativo",
            code: "código"
        }
    },
    occupation_right_types: {
        titles: "Direitos Ocupação",
        title: "Direito Ocupação",
        list: {
            name: "@:occupation_right_types.model.name",
            status: "@:occupation_right_types.model.status",
            code: "@:occupation_right_types.model.code"
        },
        model: {
            name: "Nome",
            status: "Ativo",
            code: "código"
        }
    },
    remains_types: {
        titles: "Tipos Restos Mortais",
        title: "Tipo Restos Mortais",
        list: {
            name: "@:remains_types.model.name",
            status: "@:remains_types.model.status",
            code: "@:remains_types.model.code"
        },
        model: {
            name: "Nome",
            status: "Ativo",
            code: "código"
        }
    },
    religion_types: {
        titles: "Tipos Religião",
        title: "Tipo Religião",
        list: {
            name: "@:religion_types.model.name",
            status: "@:religion_types.model.status",
            code: "@:religion_types.model.code"
        },
        model: {
            name: "Nome",
            status: "Ativo",
            code: "código"
        }
    },

    occupation_state_types: {
        titles: "Estados Ocupação",
        title: "Estado Ocupação",
        list: {
            name: "@:occupation_state_types.model.name",
            status: "@:occupation_state_types.model.status",
            code: "@:occupation_state_types.model.code"
        },
        model: {
            name: "Nome",
            status: "Ativo",
            code: "código"
        }
    },
    occupation_service_need_types: {
        titles: "Tipos Necessidade de serviço de ocupação",
        title: "Tipo Necessidade de serviço de ocupação",
        list: {
            name: "@:occupation_service_need_types.model.name",
            status: "@:occupation_service_need_types.model.status",
            code: "@:occupation_service_need_types.model.code"
        },
        model: {
            name: "Nome",
            status: "Ativo",
            code: "código"
        }
    },

    occupation_term_right_types: {
        titles: "Tipos Direito  Termo Ocupação",
        title: "Tipo Direito Termo Ocupação",
        list: {
            name: "@:occupation_term_right_types.model.name",
            status: "@:occupation_term_right_types.model.status",
            code: "@:occupation_term_right_types.model.code"
        },
        model: {
            name: "Nome",
            status: "Ativo",
            code: "código"
        }
    },
  
};
